import React, { useCallback, useEffect, useRef, useState } from 'react';

import P from 'prop-types';
import KSContainer from './../../pages/layouts/Container';
import Header from './Header';
import Sidebar from './Sidebar';

import { NotificationContainer } from 'react-notifications';
import { Connect, Disconnect, socket } from '../../services/chatAPI';

import {checkPermission} from './../../components/security'

import logo from './../../assets/logo-404.png';
import logoVIROMA from './../../assets/logo-viroma.png';
import alertSound from './../../assets/audio/alert.mp3';

//import Joyride from 'react-joyride';
import { ACCEPT_TERMS, ReadDataStorage } from '../../services/auth';
import ModalAcceptedTerms from '../modals/modal-accepted-terms';
import { Modal, Button } from 'react-bootstrap';
import ChatDataProvider from './../../components/messageView/chatContext'
import Messages from "./../../pages/maintenance/messages";

const BasePage = (props) => {
  const [company, setCompany] = useState(-1);
  const [reset, setReset] = useState(false);
  const [pages, setPages] = useState(-1);

  const [reload, setReload] = useState(false);
  const [isAttendance, setIsAttendance] = useState(false)
  const [showDisconnectModal, setShowDisconnectModal] = useState(false)
  const [disconnectedNumber, setDisconnectedNumber] = useState('')
  const alertAudioRef = useRef(null)

  const stopDisconnectAlert = useCallback(() => {
    const a = alertAudioRef.current
    if (a) {
      a.loop = false
      a.pause()
      a.currentTime = 0
    }
    setShowDisconnectModal(false)
    setDisconnectedNumber('')
  }, [])

  const disconnectModal = (
    <Modal
      show={showDisconnectModal}
      onHide={() => {}}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header className="border-danger bg-danger text-white">
        <Modal.Title>Número desconectado</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">
          O número <span style={{fontWeight:'bold', color:'#dc3545'}}>{disconnectedNumber || '—'}</span> foi desconectado do WhatsApp.
        </p>
        <p className="text-muted small mt-2 mb-0">
          O alerta sonoro continua até você confirmar.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={stopDisconnectAlert}>
        <em className="fa fa-door-closed"/>Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  )

  const handleReload = () => {
        setReload((state) => !state);
  };

  const hasTermsAccepted = useCallback(() => {
        return ReadDataStorage(ACCEPT_TERMS) === 'true';
  }, [reload]);

  useEffect(() => {
    setReset(true);
    setIsAttendance(!checkPermission(1,15))
  }, [company]);

  useEffect(() => {}, [pages]);

  useEffect(() => {
    const playDisconnectAlert = (number) => {
      if (!alertAudioRef.current) {
        alertAudioRef.current = new Audio(alertSound)
      }
      const a = alertAudioRef.current
      a.loop = true
      a.currentTime = 0
      setDisconnectedNumber(number || '')
      setShowDisconnectModal(true)
      a.play().catch((e) => console.log('[ALERT] erro ao tocar alert.mp3', e))
    }

    const onUpdate = (msg) => {
      console.log('[SOCKET][FRONT][update]', msg)
      if (msg?.type === 'number_disconnected') {
        console.log('[ALERT] tocando alert.mp3 (desconexao, loop até OK)')
        playDisconnectAlert(msg.number)
      }
    }

    if (socket === null) {
      Connect()
    }

    if (socket) {
      socket.off('update', onUpdate)
      socket.on('update', onUpdate)
    }

    return () => {
      if (socket) {
        socket.off('update', onUpdate)
      }
      const a = alertAudioRef.current
      if (a) {
        a.loop = false
        a.pause()
        a.currentTime = 0
      }
      Disconnect()
    }
  }, [])

  if (!hasTermsAccepted()) {
    return (
      <>
        <ModalAcceptedTerms showModal={true} handleReload={handleReload} />
        {disconnectModal}
        <NotificationContainer />
      </>
    );
  }

  
  return (
    <>
      <div className="wrapper">
        <Header history={props.history} callbackCompany={setCompany} isAttendance={isAttendance} setIsAttendance={setIsAttendance}/>
    

        {(!isAttendance) && (
            <Sidebar ActualCompany={company}/>
        )}

        <section className={`section-container ${isAttendance ? 'section-container-attendance' : ''}`}>
            <div id="content-tab" className={`${pages > 0 || isAttendance? 'heigth100' : 'hidden'}`}>
                {(isAttendance) ? 
                    <ChatDataProvider>
                        <Messages/>
                    </ChatDataProvider>
                :
                    <KSContainer reset={reset} callbackReset={setReset} callbackPages={setPages} /> 
                }
          </div>
          <div className='box-base'>
            {window.location.href.indexOf('viromatecnologia.com.br') > 0 ?
                    <img alt="LOGO"id="main-logo" src={logoVIROMA} style={{ maxWidth: 40 + '%', width: 30 + '%' }} />
                :
                    <img alt="LOGO"id="main-logo" src={logo} style={{ maxWidth: 40 + '%', width: 30 + '%' }} />
            }
          </div>
        </section>
      </div>
      {disconnectModal}
      <NotificationContainer />
    </>
  );
};

export default BasePage;

BasePage.propTypes = {
  history: P.string,
};
